export class RetirementUnit {
  constructor(retirement_unit_id?: string, retirement_unit_descr?: string) {
    this.retirement_unit_id = retirement_unit_id;
    this.retirement_unit_descr = retirement_unit_descr;
  }

  retirement_unit_id: string;
  retirement_unit_descr: string;
}
